import React, { useEffect, useState, useMemo } from "react";

import {
  getOpenAiApiKeyFromStorage,
  removeOpenAiApiKeyFromStorage,
  setOpenAiApiKeyFromStorage,
} from "../lib/utils";

import { LOCAL_API_STORAGE_KEY } from "../lib/constants";

import appStore from "app/AppStore";

export default function useChatSettings({
  initialSettings,
  initialApiEndpoints,
}) {
  const [hashedApiKey, setHashedApiKey] = useState(() =>
    getOpenAiApiKeyFromStorage(LOCAL_API_STORAGE_KEY)
  );

  const apiKey = useMemo(() => atob(hashedApiKey), [hashedApiKey]);

  const updateOpenAIApiKey = (key) => {
    const hashedKey = btoa(key);
    setHashedApiKey(hashedKey);
    setOpenAiApiKeyFromStorage(LOCAL_API_STORAGE_KEY, hashedKey);
  };

  const removeOpenAIApiKey = () => {
    setHashedApiKey("");
    removeOpenAiApiKeyFromStorage();
  };

  useEffect(() => {
    appStore.chatSettingsStore.setApiEndpoints(initialApiEndpoints);
    appStore.chatSettingsStore.loadChatSettings(initialSettings);
  }, []);

  return {
    apiKey,
    updateOpenAIApiKey,
    removeOpenAIApiKey,
    settings: appStore.chatSettingsStore.settings,
  };
}
